/* eslint-disable no-undef */
import { openUrl } from './util.js'
import mui from '@/assets/js/mui/mui'

document.addEventListener('plusready', function () {
  plus.runtime.setBadgeNumber(0)
  plus.push.addEventListener('click', function (msg) {
    let payload = null
    if (plus.os.name === 'Android') {
      payload = JSON.parse(msg.payload)
    } else {
      payload = msg.payload
    }
    openUrl(payload)
    plus.runtime.setBadgeNumber(0)
  }, false)

  plus.push.addEventListener('receive', function (msg) {
    let payload = null
    if (plus.os.name === 'Android') {
      payload = JSON.parse(msg.payload)
    } else {
      payload = msg.payload
    }
    const title = payload.title
    const body = payload.content
    mui.confirm(body, title, ['了解下', '没兴趣'], function (e) {
      if (e.index === 0) {
        openUrl(payload)
      }
      plus.runtime.setBadgeNumber(0)
    })
  }, false)
}, false)



// WEBPACK FOOTER //
// ./src/assets/js/push.js